import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Animated, ImageBackground, StyleSheet, Text, TextInput, View } from 'react-native';

import {
	BtnSidebarClosePng,
	InputField,
	ProfileRegistration,
	SearchTitlePng,
} from '../../../assets';
import { useDevice } from '../../../utils/hooks/useDevice';
import SvaraModal from '../Modals/SvaraModal';

interface SearchModalProps {
	onClose: () => void;
}

const SearchModal = ({ onClose }: SearchModalProps) => {
	const { t } = useTranslation();
	const opacity = useRef(new Animated.Value(0)).current;
	const [username, setUsername] = useState('');
	const { isDesktop } = useDevice();

	useEffect(() => {
		Animated.timing(opacity, {
			toValue: 1,
			duration: 200,
			useNativeDriver: true,
		}).start();

		return () => {
			opacity.setValue(0);
		};
	}, [opacity]);

	return (
		<>
			<SvaraModal
				visible
				onClose={onClose}
				backgroundImage={ProfileRegistration}
				titleImage={SearchTitlePng}
				closeIcon={BtnSidebarClosePng}
			>
				<View style={[styles.form, { minWidth: isDesktop ? 600 : 300, gap: isDesktop ? 10 : 6 }]}>
					<Text style={styles.label}>
						{t('T_SITE_MODAL_SEARCH_MESSAGE', {
							defaultValue: 'Write a table number in the field:',
						})}
					</Text>
					<ImageBackground source={InputField} resizeMode='stretch' style={styles.inputWrapper}>
						<TextInput value={username} onChangeText={setUsername} style={styles.input} />
					</ImageBackground>
				</View>
			</SvaraModal>
		</>
	);
};

const styles = StyleSheet.create({
	form: {
		alignItems: 'center',
	},
	label: {
		color: 'white',
		fontSize: 18,
		alignSelf: 'flex-start',
		marginBottom: 4,
		fontWeight: '500',
	},
	inputWrapper: {
		width: 300,
		height: 60,
		marginBottom: 20,
		justifyContent: 'center',
		paddingHorizontal: 12,
	},
	input: {
		color: 'white',
		fontSize: 20,
		padding: 0,
	},
	saveButton: {
		width: 210,
		height: 70,
		justifyContent: 'center',
		alignItems: 'center',
	},
	saveButtonText: {
		color: 'white',
		fontSize: 22,
		fontWeight: 'bold',
		textShadowColor: '#000',
		textShadowOffset: { width: 1, height: 1 },
		textShadowRadius: 2,
	},
});

export default SearchModal;
